import React from "react";
import { portfolioData } from "../data/portfolioData";

const About = () => {
  const { about, sections } = portfolioData;

  return (
    <section id="about" className="scroll-mt-24 py-14">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <h2 className="text-3xl font-bold text-slate-900">{sections.aboutTitle}</h2>
        <div className="mt-6 rounded-2xl border border-slate-200 bg-white/80 p-8 shadow-lg shadow-indigo-100/50 backdrop-blur">
          <p className="max-w-4xl text-base leading-relaxed text-slate-700">{about}</p>
        </div>
      </div>
    </section>
  );
};

export default About;
